import { Component, Input, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'ins-click-tooltip',
    templateUrl: 'click-tooltip.component.html',
    styleUrls: ['click-tooltip.component.scss'],
    exportAs: 'click-tooltip'
})
export class ClickTooltipComponent {
    @ViewChild('collapse', { static: true }) elementView: ElementRef;

    @Input() title?: string = null;
    @Input() customClass?: string = null;
    @Input() image?: boolean = false;
    @Input() imageAlt?: string;
    @Input() bottomLeft: boolean = false;
    @Input() bottomRight: boolean = false;

    public visible: boolean = false;
    public bottom: boolean = false;

    constructor(
        private elRef: ElementRef
    ) {}

    public toggle(): boolean {
        this.visible = !this.visible;

        if (this.visible) {
            const collapse_width = this.elementView.nativeElement.offsetWidth;
            const element_width = this.elRef.nativeElement.offsetWidth + collapse_width;
            const parent_width = this.elRef.nativeElement.parentElement.offsetWidth;

            this.bottom = element_width > parent_width;
        }

        return false;
    }

    public close(): boolean {
        this.visible = false;

        return false;
    }
}
